













































/*
    * Method for pupulate multi-select control - STARTS
    1.  browserAutocomplete     - HTML5 autocomplete attribute set to off (or any other value that is no "on").
    2.  chips                   - The v-chip component is used to convey small pieces of information.
    3.  columns                 - For arrange the add/edit form layout. Possible Views( multiCoumn 1 to 4).
    4.  create                  - A boolean value that indicates whether this field is shown in the create record form. Default value is true.
    5.  disabled                - For create a disabled input field. Tab index 'll be -1 for this field.
    6.  dropdown                - data object
    7.  edit                    - A boolean value that indicates whether this field is shown in the edit record form. Default value is true.
    8.  fieldName               - Name of the field.
    9.  formCreate              - Used to find the current operation of the popup field control.
    10. hint                    - The hint property on text fields adds the provided string beneath the text field
    11. placeholder             - Sets the input�s placeholder text
    12. readonly                - For create a readonly input field. Tab index 'll be -1 for this field.
    13. record                  - Object of the field.
    14. required                - For set the current field as required field. An mandatory css class added for these fields.
    15. rules                   - Vuetify includes simple validation through the rules prop.
                                  The prop accepts an array of callbacks. While validating rules, the current v-model value will be passed to the callback.
                                  This callback should return either true or a String, the error message.
    16. showInputs              - This is using for internal purpose, to check whether all the inputs are binded.
    17. title                   - A string that is shown on top of the table. This is optional.
    18. tooltip                 - The v-tooltip component is useful for conveying information when a user hovers over an element.
    19. tooltipList             - The v-tooltip component is useful for conveying all field information when a user hovers over an element.
*/
import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";
import TooltipComponents from "./../../../../../Tooltips/Tooltips.vue";

/*
    * Component's properties and events
*/
@Component({
     components: { TooltipComponents }
})

export default class MultiSelectComponent extends Vue  {
    /*
        * Component's props
    */
    @Prop() readonly browserAutocomplete!: string;
    @Prop() readonly chips!: string;
    @Prop() readonly columns!: string;
    @Prop() readonly create!: string;
    @Prop() readonly disabled!: string;
    @Prop() readonly dropdown!: string;
    @Prop() readonly edit!: string;
    @Prop() readonly fieldName!: string;
    @Prop() readonly formCreate!: string;
    @Prop() readonly hint!: string;
    @Prop() readonly parentName!: string;
    @Prop() readonly placeholder!: string;
    @Prop() readonly readonly!: string;
    @Prop() readonly record!: string;
    @Prop() readonly required!: string;
    @Prop() readonly rules!: string;
    @Prop() readonly showInputs!: string;
    @Prop() readonly title!: string;
    @Prop() readonly tooltip!: string;
    @Prop() readonly tooltipList!: string;
    @Prop() readonly inline!: string;

    /*
        * Component's variables
    */
    private tooltipIcon: boolean = false;
    private tooltipOption: boolean = false;
    private show: boolean = false;
    private translateKey: string = "";

    /*
        *  A component’s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
        *  tooltipIcon - tootip icon show in mouseover
        *  tooltipOption - tootip dialog show in mouseover
        *  translateKey - translated key field
    */
    data() {
        return { translateKey: "", tooltipIcon: false, tooltipOption: false };
    }

    _tpShowTooltip() {
        if (!this.tooltip) {
            return;
        }

        this.tooltipOption = true;
    }

    /*
        * It performs the dropdown selection change event.
    */
    _msChange(e) {
        let context = this.$store.state[this.parentName];
        
        //#.Check is dirty
        context.isDirty = true;
    }

    /*
        * Method for remove tooltip
    */
    _tpRemoveTooltip() {
        if (!this.tooltip) {
            return;
        }

        this.tooltipOption = false;
        this.tooltipIcon = false;
    }  

    /*
        *  Key translator
    */
    get translator(): string {
        let context = this.$store.state[this.parentName];

        if (context && !context.keyTranslator) {
            this.translateKey = this.title;
            return this.translateKey;
        }

        this.translateKey = (this.$t(this.title) || this.title).toString();
        return this.translateKey;
    }
}
